export interface MapboxStaticMarker {
  coordinates: [number, number];
}

export interface MapboxStaticImageOptions {
  positioning: string;
  width: number;
  height: number;
  markers?: MapboxStaticMarker[];
  retina?: boolean;
  padding?: string;
}

// Hébergé hors du projet : les serveurs Mapbox téléchargent eux-mêmes cette image et aucune de nos
// origines ne leur est joignable (localhost, capacitor://, et carnet.ffessm.fr → « image not found »).
const MARKER_URL = "https://samrm.net/misc/marker.png";

// Mapbox dessine le dernier overlay au-dessus : on ordonne du nord au sud pour que
// les marqueurs les plus au sud (plus bas dans l'image) recouvrent ceux du nord.
function markersOverlay(markers: MapboxStaticMarker[]): string {
  return [...markers]
    .sort((a, b) => b.coordinates[1] - a.coordinates[1])
    .map(({ coordinates: [lng, lat] }) => `url-${encodeURIComponent(MARKER_URL)}(${lng},${lat})`)
    .join(",");
}

export function mapboxStaticImageUrl({ positioning, width, height, markers = [], retina = false, padding }: MapboxStaticImageOptions): string {
  const username = import.meta.env.VITE_MAPBOX_USERNAME;
  const styleId = import.meta.env.VITE_MAPBOX_STYLE_ID;
  const accessToken = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;
  const overlay = markers.length ? `${markersOverlay(markers)}/` : "";
  const dimensions = `${width}x${height}${retina ? "@2x" : ""}`;
  const paddingParam = padding ? `&padding=${padding}` : "";
  return `https://api.mapbox.com/styles/v1/${username}/${styleId}/static/${overlay}${positioning}/${dimensions}?access_token=${accessToken}&attribution=false&logo=false${paddingParam}`;
}

export function mapboxStaticPositioning(center: [number, number], zoom: number): string {
  return `${center[0]},${center[1]},${zoom},0`;
}
